import { alpha, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import {
  Box,
  Chip,
  IconButton,
  Stack,
  Tooltip,
  Typography
} from '@mui/material';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';

import Search from './Search';
import Profile from './Profile';
import MobileSection from './MobileSection';
import Logo from '@components/logo';
import { useThemeMode } from '../../../../themes/ThemeModeContext';

function ThemeToggleButton({ compact = false }) {
  const theme = useTheme();
  const { mode, toggleColorMode } = useThemeMode();
  const isDark = mode === 'dark';

  return (
    <Tooltip title={isDark ? 'Light mode' : 'Dark mode'}>
      <IconButton
        onClick={toggleColorMode}
        size={compact ? 'medium' : 'large'}
        aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        sx={{
          color: 'text.secondary',
          backgroundColor: alpha(theme.palette.background.paper, theme.palette.mode === 'dark' ? 0.92 : 0.72),
          '&:hover': {
            color: 'text.primary',
            backgroundColor: theme.palette.action.hover
          }
        }}
      >
        {isDark ? <LightModeRoundedIcon fontSize="small" /> : <DarkModeRoundedIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
}
export default function HeaderContent() {
  const theme = useTheme();
  const downLG = useMediaQuery((muiTheme) => muiTheme.breakpoints.down('lg'));

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} sx={{ width: '100%' }}>
      <Stack direction="row" alignItems="center" spacing={2} sx={{ minWidth: 0 }}>
        <Logo />
        {!downLG && (
          <Box>
            <Typography variant="h5" sx={{ lineHeight: 1.1 }}>
              IELTS Gurus Workspace
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 0.5 }}>
              <AccessTimeRoundedIcon sx={{ fontSize: 15, color: 'text.secondary' }} />
              <Typography variant="body2" color="text.secondary">
                Học tập tập trung, theo sát hạn nộp và tiến độ của bạn.
              </Typography>
            </Stack>
          </Box>
        )}
      </Stack>

      {!downLG && (
        <Stack direction="row" spacing={1.25} alignItems="center" sx={{ flexShrink: 0 }}>
          <Search />
          <Chip
            label="Trang chủ"
            size="small"
            sx={{
              borderRadius: 999,
              backgroundColor: alpha(theme.palette.primary.main, 0.1),
              color: 'primary.main',
              fontWeight: 700
            }}
          />
          <ThemeToggleButton />
          <Profile />
        </Stack>
      )}

      {downLG && (
        <Stack direction="row" spacing={1} alignItems="center">
          <ThemeToggleButton compact />
          <MobileSection />
        </Stack>
      )}
    </Stack>
  );
}
